export default "__VITE_ASSET__DMAxmNU2__"